import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 6l0 -3","key":"svg-0"}],["path",{"d":"M6 12l-3 0","key":"svg-1"}],["path",{"d":"M7.75 7.75l-2.15 -2.15","key":"svg-2"}]]

/**
 * IconLoaderQuarter
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbG9hZGVyLXF1YXJ0ZXIiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEyIDZsMCAtMyIgLz4KICA8cGF0aCBkPSJNNiAxMmwtMyAwIiAvPgogIDxwYXRoIGQ9Ik03Ljc1IDcuNzVsLTIuMTUgLTIuMTUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/loader-quarter
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLoaderQuarter = createReactComponent('outline', 'loader-quarter', 'LoaderQuarter', __iconNode);

export default IconLoaderQuarter;